export default httpClient => ({

    save: async ({token, cliente_id, autenticacao, seller_id}) => {
        const response = await httpClient.post('/usuarios-mercado-livre/salvar', {cliente_id,autenticacao,seller_id},{ headers: { "Authorization": "Bearer " + token}  });
        return {
            data: response.data
        }
    },

    verificarUsuarioML: async (dados) => {
        const response = await httpClient.get('/verificar-usuario-ml/'+dados.empresa_id, { headers: { "Authorization": "Bearer " + dados.token}  });
        return {
            data: response.data
        }
    },
/*
    saveDataAndCreateToken: async (dados) => {
        const response = await httpClient.post('/salvar-dados-gerar-token', dados);
        console.log(dados)
        return {
            data: response.data
        }
    },
*/

    getAll: async () => {
        const response = await httpClient.get('/usuarios-mercado-livre')
        return {
            data: response.data,
        }
    },
    getById: async ({ cliente_id, token }) => {
        const response = await httpClient.get('/clientes/' + cliente_id, { headers: { "Authorization": "Bearer " + token}  })
        return {
            data: response.data,
        }
    },

    getByClienteID: async ({ empresa_id, token }) => {
        const response = await httpClient.get('/user-mercado-livre/por-cliente/' + empresa_id, { headers: { "Authorization": "Bearer " + token}  })
        return {
            data: response.data,
        }
    },

    update: async (dados) => {
        const response = await httpClient.put('/usuarios-mercado-livre/alterar/' + dados.id, dados, { headers: { "Authorization": "Bearer " + dados.token } } );
        return {
            data: response.data
        }
    },
    delete: async ({ id }) => {
        const response = await httpClient.delete('/usuarios-mercado-livre/deletar/' + id);
        return {
            data: response
        }
    },
});